import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d954da5c")

_pushScopeId("data-v-d954da5c")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "paymentSection" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = { class: "titleContainer" }
const _hoisted_6 = { class: "pageTitle" }
const _hoisted_7 = { class: "contentContainer" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "textBlock" }
const _hoisted_10 = {
  href: "#",
  class: "btnIconType3"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "icon-arrow" }, null, -1)
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "apiBlock" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "codeBlock" }
const _hoisted_16 = { class: "headBlock" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "contentBlock" }, [
  /*#__PURE__*/_createVNode("button", { class: "btnIconType4" }, [
    /*#__PURE__*/_createVNode("span", { class: "text" }, "Run")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.t('titleContainer.pageTitle[0]')) + " ", 1),
              _createVNode("span", null, _toDisplayString(_ctx.t('titleContainer.pageTitle[1]')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("p", null, _toDisplayString(_ctx.t('contentContainer.textBlock')), 1)
              ])
            ]),
            _createVNode("a", _hoisted_10, [
              _hoisted_11,
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t('contentContainer.download')), 1)
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("span", _hoisted_14, _toDisplayString(_ctx.t('contentContainer.try')), 1),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("span", null, _toDisplayString(_ctx.t('contentContainer.title')), 1)
                ]),
                _hoisted_17
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
})